import React from 'react';
import PropTypes from 'prop-types';

import MenuItem from 'material-ui/MenuItem';
import InfoSelectField from 'ntnu-react/material/InfoSelectField';
import InfoTextField from 'ntnu-react/material/InfoTextField';
import PersonPicker from 'ntnu-react/material/PersonPicker';
import { searchPerson } from '../utils';

import info from '../constants/infotexts.json';

const styles = {
    row: {
        marginTop: '2em',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
    },
    flexLeft: {
        flex: 1,
        marginRight: 12,
    },
    flexRight: {
        flex: 1,
        marginLeft: 12,
    },
};

const MAX_LENGTH_EXCEEDED = 'Felt må har mindre en 255 tegn.';

class GeneralTab extends React.Component {

    state = {
        titleError : '',
    };

    handleSelectChange = (field, recalc) => {
        return (e, index, value) => {
            this.props.fieldChange(`GeneralData.${field}`, value, recalc);
        };
    }

    handleTextChange = (field, recalc) => {
        return (e) => {
            this.props.fieldChange(`GeneralData.${field}`, e.target.value, recalc);
        };
    }

    handleSingleLineTextChange = (field, recalc) => {
        return (e) => {
            if(e.target.value && e.target.value.length >= 255) {
                this.setState( {titleError: MAX_LENGTH_EXCEEDED});
            } else {
                this.setState( {titleError: null});
                this.props.fieldChange(`GeneralData.${field}`, e.target.value, recalc);
            }
        };
    }

    handlePeopleChange = (field, recalc) => {
        return (name) => {
            this.props.fieldChange(`GeneralData.${field}`, name, recalc);
        };
    }

    handlePeopleSearch = (text) => {
        return searchPerson(text);
    }

    render() {
        const { data, costCenters } = this.props;
        return (
            <section>
                <InfoTextField
                    floatingLabelText="Forslagstittel"
                    value={data.Title}
                    fullWidth={true}
                    onChange={this.handleSingleLineTextChange('Title')}
                    required={true}
                    errorText={this.state.titleError}
                    disabled={this.props.disabled}
                />

                <InfoTextField
                    floatingLabelText="Kort beskrivelse av behov"
                    infoText={info.general.need}
                    value={data.DescriptionOfNeed}
                    fullWidth={true}
                    onChange={this.handleTextChange('DescriptionOfNeed')}
                    required={true}
                    multiLine={true}
                    rows={4}
                    disabled={this.props.disabled}
                />

                <div style={styles.row}>
                    <InfoTextField
                        floatingLabelText="Nytteverdi"
                        infoText={info.general.benefit}
                        value={data.Benefit}
                        fullWidth={true}
                        onChange={this.handleTextChange('Benefit')}
                        required={true}
                        wrapStyle={styles.flexLeft}
                        multiLine={true}
                        rows={3}
                        disabled={this.props.disabled}
                    />

                    <InfoTextField
                        floatingLabelText="Omfang"
                        infoText={info.general.scope}
                        value={data.Scope}
                        fullWidth={true}
                        onChange={this.handleTextChange('Scope')}
                        required={true}
                        wrapStyle={styles.flexRight}
                        multiLine={true}
                        rows={3}
                        disabled={this.props.disabled}
                    />
                </div>

                <div style={styles.row}>
                    <InfoTextField
                        floatingLabelText="Risiko"
                        infoText={info.general.risk}
                        value={data.Risk}
                        fullWidth={true}
                        onChange={this.handleTextChange('Risk')}
                        required={true}
                        wrapStyle={styles.flexLeft}
                        multiLine={true}
                        rows={3}
                        disabled={this.props.disabled}
                    />

                    <InfoTextField
                        floatingLabelText="Strategisk"
                        infoText={info.general.strategy}
                        value={data.Strategic}
                        fullWidth={true}
                        onChange={this.handleTextChange('Strategic')}
                        required={true}
                        wrapStyle={styles.flexRight}
                        multiLine={true}
                        rows={3}
                        disabled={this.props.disabled}
                    />
                </div>

                <div style={styles.row}>
                    <PersonPicker
                        floatingLabelText="Kontaktperson virksomhet/kunde"
                        value={data.ClientContact}
                        onChange={this.handlePeopleChange('ClientContact')}
                        fullWidth={true}
                        wrapStyle={styles.flexLeft}
                        onSearch={this.handlePeopleSearch}
                        disabled={this.props.disabled}
                    />

                    <PersonPicker
                        floatingLabelText="Kontaktperson IT"
                        value={data.ItContact}
                        onChange={this.handlePeopleChange('ItContact')}
                        fullWidth={true}
                        wrapStyle={styles.flexRight}
                        onSearch={this.handlePeopleSearch}
                        disabled={this.props.disabled}
                    />
                </div>

                <InfoSelectField
                    floatingLabelText="Hovedeier/forvalter av tjenesten"
                    value={data.MainAdmin}
                    autoWidth={true}
                    onChange={this.handleSelectChange('MainAdmin')}
                    disabled={this.props.disabled}
                >
                    {costCenters.map((cc) => (
                        <MenuItem
                            key={cc.key}
                            value={cc.key}
                            primaryText={cc.text}
                            insetChildren={true}
                            checked={data.MainAdmin === cc.key}
                        />
                    ))}
                </InfoSelectField>

                <InfoTextField
                    floatingLabelText="Hovedbruker av tjenesten"
                    infoText="Fagmiljø, administrasjon, fellestjeneste/bruker, prosess/systemeiere, interne IT-prosesser."
                    value={data.MainUser}
                    fullWidth={true}
                    onChange={this.handleTextChange('MainUser')}
                    required={true}
                    multiLine={true}
                    rows={4}
                    disabled={this.props.disabled}
                />

            </section>
        );
    }
}

GeneralTab.propTypes = {
    data: PropTypes.object.isRequired,
    costCenters: PropTypes.array.isRequired,
    fieldChange: PropTypes.func.isRequired,
    style: PropTypes.object,
    disabled: PropTypes.bool,
};

export default GeneralTab;



// WEBPACK FOOTER //
// ./src/components/GeneralTab.js